import { sendToNative } from 'app/webview/utils'

/**
 *
 * NOTE: Using previous version of create/edit
 * goal functions for Android support
 */
export const createGoalAndroid = (year: number) => {
  sendToNative({
    id: 'create-reading-goal',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/reading_goals_edit?create=${year}`,
        close: true,
      },
    },
  })
}
